import angular from 'angular';

import ComponentModule from './component';
import CalendarDashboardComponent from './calendar-dashboard.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-dashboard', [
        ComponentModule.name
    ])
    .component(CalendarDashboardComponent.selector, CalendarDashboardComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-dashboard/index.js